import { Directive, ElementRef, QueryList } from '@angular/core';
import { EntityTypeConfig } from '@model/entity-type-config';
import { RestService } from '@service/rest/rest.service';
import { SentryService } from '@service/sentry.service';

@Directive()
export class ImpressionCounter {
  /*
    this is an index which list items are currently where on the screen and how tall
    this is necessary to calculate which item is in view
  */
  public index = {};
  public elem_arr = [];

  private RestService: RestService = null;
  private SentryService: SentryService = null;
  public anchors: QueryList<ElementRef>;

  constructor(init: { RestService: RestService; SentryService: SentryService }) {
    this.RestService = init.RestService;
    this.SentryService = init.SentryService;
  }

  ngAfterViewInit() {
    this.anchors.changes.subscribe((c) => {
      this.index = {};
      this.elem_arr = [];

      c.toArray().forEach((el) => {
        let position = this.getPosition(el.nativeElement);

        this.index[el.nativeElement.id] = {
          el,
          height: el.nativeElement.offsetHeight,
          blocked: null,
          y: position.y,
        };

        this.elem_arr.push(el.nativeElement.id);
      });

      // console.log(this.index, this.elem_arr)
    });
  }

  public onScroll(event) {
    let screen_middle = window.pageYOffset + window.innerHeight / 2;

    // console.log(JSON.stringify(this.elem_arr))

    // get all elements that are possibly in the screen
    let visible_element_ids = this.elem_arr
      .filter((id) => {
        let element_bottom = this.index[id].y + this.index[id].height;
        return screen_middle > this.index[id].y && screen_middle < element_bottom;
      })
      .map((id) => {
        // console.log(id)
        this.sendImpressionIfOK(this.index[id]);
      });

    // console.log(JSON.stringify(visible_element_ids))
  }

  /**
   * returns the absolute position of an element regardless of position/float/flex issues
   * @param {HTMLElement} el - element to return position for
   * @returns {object} { x: num, y: num }
   */
  private getPosition(el) {
    var x = 0;
    var y = 0;

    while (el != null && (el.tagName || '').toLowerCase() != 'html') {
      x += el.offsetLeft || 0;
      y += el.offsetTop || 0;
      // el = el.parentElement
      el = el.offsetParent;
    }

    return { x: parseInt(x + '', 10), y: parseInt(y + '', 10) };
  }

  public sendImpressionIfOK(index_entry) {
    if (!index_entry.blocked) {
      let data = {
        model: index_entry.el.nativeElement.getAttribute('data-entitytype'),
        model_id: index_entry.el.nativeElement.id,
      };

      // send count++
      this.RestService.post('impression/add', data, undefined, false).catch((err) => {
        this.SentryService.silentCaptureException(err);
      });

      // block it
      index_entry.blocked = setTimeout(() => {
        index_entry.blocked = null;
      }, 60000);
    }
  }
}
